import { Collapse, Flex, Typography } from 'antd';
import { useTranslation } from 'translations/hooks';

import {
  HeaderType,
  ReportHeader,
} from 'business/quality-control/pages/defect-report-history/components/defect-report-details-drawer/components/report-header';
import { DefectReportHistory } from 'business/quality-control/pages/defect-report-history/components/defect-report-table';
import { useGetRepairReportPicturesData } from 'business/quality-control/pages/defect-report-history/hooks/data/get-repair-report-pictures';
import { DefectReportStatus } from 'business/quality-control/pages/defect-report-history/hooks/data/types';
import { formatDateWithMiddleDot } from 'technical/format/date';
import { Picture, PicturesList } from 'ui/pictures';

const { Text } = Typography;

export const DefectReportDetailsRepair = ({
  report,
}: {
  report: DefectReportHistory;
}) => {
  const { t } = useTranslation();

  const { data: picturesData, isLoading } = useGetRepairReportPicturesData(
    report.repairId,
  );
  const repairPictures: Picture[] = picturesData
    ? picturesData?.pictures.map((item) => ({
        description: item.id,
        path: item.path,
      }))
    : [];

  return (
    <Collapse
      defaultActiveKey={['1']}
      expandIconPosition="end"
      style={{ background: '#fff' }}
      items={[
        {
          key: '1',
          label: (
            <ReportHeader
              status={report.status as DefectReportStatus}
              type={HeaderType.repair}
            />
          ),
          children: (
            <>
              <Flex vertical>
                <Text type="secondary">
                  {t('qualityControl.defectReportHistory.repairDate')}
                </Text>
                <Text strong>{formatDateWithMiddleDot(report.repairDate)}</Text>
              </Flex>

              <Flex vertical style={{ marginTop: '20px' }}>
                <Text type="secondary">
                  {t('qualityControl.defectReportHistory.comment')}
                </Text>
                <Text>{report.repairDescription || '-'}</Text>
              </Flex>

              <Flex vertical style={{ marginTop: '20px' }}>
                <Text type="secondary">
                  {t('qualityControl.defectReportHistory.author')}
                </Text>
                <Text strong>{report.repairAuthor}</Text>
              </Flex>

              <Flex vertical style={{ marginTop: '20px' }}>
                <PicturesList pictures={repairPictures} isLoading={isLoading} />
              </Flex>
            </>
          ),
        },
      ]}
    />
  );
};
